import productInitialState from './initial-state';
import { SET_ITEMS, SET_CATEGORIES } from './types';

export default function productReducer(state = productInitialState, action) {
  switch (action.type) {
    case SET_ITEMS: {
      const { items } = action.payload;
      return { ...state, items };
    }
    case SET_CATEGORIES: {
      const { categories } = action.payload;
      return { ...state, categories };
    }
    default:
      return state;
  }
}
